import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "navbar-brand" }

import VPNavbarBrand from '@theme/VPNavbarBrand.vue'
import VPNavbarItems from '@theme/VPNavbarItems.vue'
import VPToggleColorModeButton from '@theme/VPToggleColorModeButton.vue'
import VPToggleSidebarButton from '@theme/VPToggleSidebarButton.vue'
import { useThemeLocaleData } from '@theme/useThemeData'
import { DeviceType, useUpdateDeviceStatus } from '@theme/useUpdateDeviceStatus'
import { hasGlobalComponent } from '@vuepress/helper/client'
import type { VNode } from 'vue'
import { computed, ref, resolveComponent, useTemplateRef } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPNavbar',
  emits: ["toggleSidebar"],
  setup(__props) {





const SearchBox = hasGlobalComponent('SearchBox')
  ? resolveComponent('SearchBox')
  : (): null => null

const themeLocale = useThemeLocaleData()

const navbar = useTemplateRef<HTMLElement | null>('navbar')
const navbarBrand = useTemplateRef<HTMLElement | null>('navbar-brand')

const linksWrapperMaxWidth = ref(0)
const linksWrapperStyle = computed(() => {
  if (!linksWrapperMaxWidth.value) {
    return {}
  }
  return {
    maxWidth: `${linksWrapperMaxWidth.value}px`,
  }
})

const getCssValue = (el: HTMLElement | null, property: string): number => {
  // NOTE: Known bug, will return 'auto' if style value is 'auto'
  const val = el?.ownerDocument.defaultView?.getComputedStyle(el, null)[
    property as keyof CSSStyleDeclaration
  ]

  const num = Number.parseInt(val as string, 10)

  return Number.isNaN(num) ? 0 : num
}

useUpdateDeviceStatus(
  DeviceType.Mobile,
  (mobileDesktopBreakpoint: number): void => {
    // avoid overlapping of long title and long navbar links
    const navbarHorizontalPadding =
      getCssValue(navbar.value, 'paddingLeft') +
      getCssValue(navbar.value, 'paddingRight')
    if (window.innerWidth < mobileDesktopBreakpoint) {
      linksWrapperMaxWidth.value = 0
    } else {
      linksWrapperMaxWidth.value =
        navbar.value!.offsetWidth -
        navbarHorizontalPadding -
        (navbarBrand.value?.offsetWidth ?? 0)
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    ref_key: "navbar",
    ref: navbar,
    class: "vp-navbar",
    "vp-navbar": ""
  }, [
    _createVNode(VPToggleSidebarButton, {
      onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar')))
    }),
    _createElementVNode("span", _hoisted_1, [
      _createVNode(VPNavbarBrand)
    ], 512),
    _createElementVNode("div", {
      class: "vp-navbar-items-wrapper",
      style: _normalizeStyle(linksWrapperStyle.value)
    }, [
      _renderSlot(_ctx.$slots, "before"),
      _createVNode(VPNavbarItems, { class: "vp-hide-mobile" }),
      _renderSlot(_ctx.$slots, "after"),
      (_unref(themeLocale).colorModeSwitch)
        ? (_openBlock(), _createBlock(VPToggleColorModeButton, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(SearchBox))
    ], 4)
  ], 512))
}
}

})